import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { RouteEnum } from '@enum/route.enum';
import { useVerifyUserMutation } from '@hook/auth/auth.hooks';
import { isString } from '@util/data/is-exist';

export const useVerify = () => {
  const navigate = useNavigate();
  const { key = '' } = useParams();

  const [verify, { status }] = useVerifyUserMutation();

  useEffect(() => void (isString(key) && verify(key).unwrap()), [key]);

  useEffect(
    () => void ((status === 'fulfilled' || status === 'rejected') && navigate(RouteEnum.Dashboard.path)),
    [status],
  );
};
